<template>
  <v-app id="inspire" class="app dashboard">
    <app-drawer class="app--drawer" :show-drawer="showDrawer" />
    <app-toolbar class="app--toolbar" @side-icon-click="handleDrawerVisible" />
    <v-content>
      <!-- Page Header -->
      <page-header></page-header>
      <div class="page-wrapper"><router-view /></div>
    </v-content>
    <!-- Go to top -->
    <app-fab />
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import AppFab from '@/components/AppFab'
import PageHeader from '@/components/PageHeader'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
  },

  data() {
    return {
      showDrawer: false,
    }
  },
  methods: {
    handleDrawerVisible() {
      this.showDrawer = !this.showDrawer
    },
  },
  created() {},
}
</script>

<style lang="sass" scoped>

.page-wrapper
  min-height: calc(100vh - 70px - 81px)
</style>
